// Enige waarheidsbron voor tenants in de web-app.
// LET OP: Vite vervangt `import.meta.env.VITE_X` statisch bij build. Dynamisch
// samengestelde keys (import.meta.env[`VITE_${code}_...`]) worden NIET vervangen
// en zijn undefined — daarom staat elke env-var hier expliciet benoemd.
export const TENANT_CODES = ['VRU', 'VRZL'] as const;
export type TenantCode = (typeof TENANT_CODES)[number];

export function isTenantCode(value: unknown): value is TenantCode {
  return typeof value === 'string' && (TENANT_CODES as readonly string[]).includes(value);
}

export interface TenantConfig {
  label: string;
  clientId: string;
  authority: string;
  redirectUri: string;
}

// GitHub Environments accepteren geen lege waarde, dus staan er placeholders als
// ' ' in de vars, en een copy/paste laat makkelijk een \r\n achter. Zonder trim
// stuurt MSAL die whitespace mee in scope of redirect-uri en faalt de login.
const trimmed = (value: string | undefined) => value?.trim() ?? '';

export const TENANTS: Record<TenantCode, TenantConfig> = {
  VRU: {
    label: 'Veiligheidsregio Utrecht',
    clientId: trimmed(import.meta.env.VITE_VRU_MSAL_CLIENT_ID),
    authority: trimmed(import.meta.env.VITE_VRU_MSAL_AUTHORITY_URL),
    redirectUri: trimmed(import.meta.env.VITE_MSAL_REDIRECT_URI),
  },
  VRZL: {
    label: 'Veiligheidsregio Zuid-Limburg',
    clientId: trimmed(import.meta.env.VITE_VRZL_MSAL_CLIENT_ID),
    authority: trimmed(import.meta.env.VITE_VRZL_MSAL_AUTHORITY_URL),
    redirectUri: trimmed(import.meta.env.VITE_MSAL_REDIRECT_URI),
  },
};
